import type { DisciplineInsight } from "../providers/dataContext.js";

interface DisciplineInsightsProps {
  insights: DisciplineInsight[];
}

const KIND_LABELS: Record<DisciplineInsight["kind"], string> = {
  time_of_day: "Time",
  symbol_bias: "Symbol",
  mistake_tag: "Journal",
};

export function DisciplineInsights({ insights }: DisciplineInsightsProps) {
  if (insights.length === 0) return null;
  return (
    <section className="panel">
      <div className="panel__hdr">
        <h2 className="panel__title">Discipline insights</h2>
      </div>
      <div className="insights">
        {insights.map((item) => (
          <div className={`insights__row insights__row--${item.severity}`} key={`${item.kind}:${item.label}:${item.detail}`}>
            <div className="insights__badge">{KIND_LABELS[item.kind]}</div>
            <div className="insights__copy">
              <div className="insights__label">{item.label}</div>
              <div className="insights__detail">{item.detail}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
